/**
Project: Voice Panel (c)
Title: Signin 
Description: Component to check whether browser or teams sign in 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import SigninInteractive from "./signin-interactive";
import SigninSilent from "./signin-silent";
import { setClientNavigator } from "../actions/common-actions";
import { connect } from "react-redux";
import IntlUtil from "../helpers/intl-util";
import { AppConstants } from "../settings/app-constants";
import axios from "axios";
import { AppPageTitle } from "../components/app-page-title";
import { AppURLProps } from "../settings/app-urls";
import { AppConfigProps } from "../settings/app-config";

class Signin extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_signin = "signin";

  constructor(props) {
    super(props);
    this.state = {
      whitelistDomainsData: null,
      errorMessage: null,
      errorDetails: null,
      isPageDataFetched: false,
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  async componentDidMount() {
    this._isMounted = true;
    localStorage.removeItem(AppConfigProps.identitySession.voiceAdminTokenKey);
    localStorage.removeItem(
      AppConfigProps.identitySession.voiceAdminIdleTimerKey
    );
    localStorage.removeItem(
      AppConfigProps.identitySession.voiceAdminSessionTimerKey
    );
    await this.checkAdminConsent();
  }

  checkAdminConsent = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const adminConsentGranted =
      urlParams.get("admin_consent") === "True" ? true : false;
    if (adminConsentGranted) {
      // Notify the parent window that admin consent was granted
      if (window.self.name?.toLowerCase().trim() === "childwindow") {
        if (window.opener) {
          window.opener.location.href = `${window.location.origin}${AppURLProps.signin}`;
        }
        window.close();
      }
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  render() {
    if (this.props.clientNavigator !== null) {
      return (
        <>
          <AppPageTitle
            pageTitle={IntlUtil.getText(this._intl_ns_signin, "title.signin")}
          />
          {this.props.clientNavigator &&
          this.props.clientNavigator.accessMode ===
            AppConstants.CLIENT_NAVIGATOR.ACCESS_MODE_REGULAR_BROWSER ? (
            <SigninInteractive
              history={this.props.history}
              isPageDataFetched={this.state.isPageDataFetched}
            />
          ) : (
            <SigninSilent
              history={this.props.history}
              isPageDataFetched={this.state.isPageDataFetched}
            />
          )}
        </>
      );
    }

    return <></>;
  }
}

const mapStateToProps = (state) => ({
  clientNavigator: state.appSettings.clientNavigator,
});
const mapActionToProps = {
  setClientNavigator,
};

export default connect(mapStateToProps, mapActionToProps)(Signin);
